class ProductCardCarousel extends HTMLElement {
  constructor() {
    super();
    this.mediaItems = Array.from(this.querySelectorAll(':scope > .media'));
    if (this.mediaItems.length < 2) return;

    this.mediaQuery = window.matchMedia(theme.config.mediaQuerySmall);
    this.isMobile = this.mediaQuery.matches;

    if (this.hasAttribute('data-mobile-only') && !this.isMobile) return;

    if (this.isMobile) {
      this.initMobile();
    } else {
      Motion.inView(this, this.initDesktop.bind(this), { margin: '200px 0px 200px 0px' });
    }
  }

  initMobile() {
    this.classList.add('product-card__carousel--mobile');

    // Dots auf Mobile deaktiviert — bei Bedarf wieder einkommentieren.
    // const dots = document.createElement('div');
    // dots.className = 'product-card__carousel-dots';
    // this.dotButtons = this.mediaItems.map((_, i) => {
    //   const btn = document.createElement('button');
    //   btn.type = 'button';
    //   btn.className = 'product-card__carousel-dot';
    //   btn.setAttribute('aria-label', `Bild ${i + 1} von ${this.mediaItems.length}`);
    //   btn.setAttribute('tabindex', '-1');
    //   if (i === 0) btn.classList.add('is-active');
    //   dots.appendChild(btn);
    //   return btn;
    // });
    // this.parentNode.appendChild(dots);
    //
    // const observer = new IntersectionObserver(
    //   (entries) => {
    //     entries.forEach(entry => {
    //       if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
    //         const idx = this.mediaItems.indexOf(entry.target);
    //         if (idx >= 0) {
    //           this.dotButtons.forEach(b => b.classList.remove('is-active'));
    //           this.dotButtons[idx].classList.add('is-active');
    //         }
    //       }
    //     });
    //   },
    //   { root: this, threshold: 0.5 }
    // );
    // this.mediaItems.forEach(item => observer.observe(item));
  }

  initDesktop() {
    if (this.mediaItems.length === 2) {
      this.classList.add('without-dots');
    }

    this.style.visibility = 'hidden';
    this.carousel = new Flickity(this, {
      accessibility: false,
      draggable: false,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      rightToLeft: theme.config.rtl,
      on: {
        ready: () => {
          this.style.visibility = 'visible';
        }
      }
    });

    this.onMoveHandler = this.onMoveHandler.bind(this);
    this.onLeaveHandler = this.onLeaveHandler.bind(this);
    this.addEventListener('mousemove', this.onMoveHandler);
    this.addEventListener('mouseleave', this.onLeaveHandler);
  }

  onMoveHandler(event) {
    if (!this.carousel) return;
    const count = this.mediaItems.length;
    if (count === 2) return this.carousel.select(1);

    const { width } = this.carousel.size;
    const mouseX = event.clientX - this.getBoundingClientRect().left;

    if (count === 3) {
      return this.carousel.select(mouseX < width / 2 ? 1 : 2);
    }
    if (count === 4) {
      if (mouseX < width / 3) return this.carousel.select(1);
      if (mouseX < (2 * width) / 3) return this.carousel.select(2);
      return this.carousel.select(3);
    }
  }

  onLeaveHandler() {
    if (this.carousel) this.carousel.select(0);
  }

  disconnectedCallback() {
    if (this.carousel) this.carousel.destroy();
  }
}

customElements.define('product-card-carousel', ProductCardCarousel);
